const gccsBillingTrialNotification = {
  controller: 'SecurityManagerBillingTrialNotificationController',
  controllerAs: 'billingTrialNotificationCtrl',
  template: require('./template.html')
};

angular.module('public.security-manager.billing')
  .component('gccsBillingTrialNotification', gccsBillingTrialNotification);
